import React, { useState } from "react";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { theme as themeConfig } from "../../themes/themes";

const DateCalendarComponent = ({
  keyId,
  componentConfiguration,
  setQualificationDateOption,
  idQuestion,
  typeQuestion,
}) => {
  const [startDate, setStartDate] = useState();
  return (
    <>
      <DatePicker
        key={keyId}
        selected={startDate}
        onChange={(date) => {
          setStartDate(date);
          setQualificationDateOption(
            moment(date, "MMMM D, yyyy h:mm aa").format("MMMM D, yyyy h:mm a"),
            idQuestion,
            typeQuestion
          );
        }}
        showTimeSelect
        dateFormat="MMMM d, yyyy h:mm aa"
        maxDate={
          componentConfiguration.disableFutureDates ? moment().toDate() : null
        }
        customInput={
          <div
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              backgroundColor: themeConfig.background.tertiary,
              justifyContent: "center",
              height: "65px",
            }}
          >
            <AccessTimeFilledIcon
              style={{
                cursor: "pointer",
                fontSize: "29px",
                paddingRight: "10px",
              }}
            />{" "}
            <span style={{ color: "gray", cursor: "pointer" }}>
              {startDate
                ? `${moment(startDate, "MMMM D, yyyy h:mm aa").format(
                  "MMMM D, yyyy h:mm a"
                )}`
                : "Select a date and time"}
            </span>
          </div>
        }
      />
    </>
  );
};

export default DateCalendarComponent;
